// @flow

import { createdAtField, getCreatedAtSort, idField, StoredEntity } from '../abstract/StoredEntity';
import type { Endpoints, EntityFieldCollection, SortParams } from '../types';
import PolicyEntityAction from './PolicyEntityAction';
import { constructEndpoints } from '../helpers';

export const PolicyPermissionAction = {
    viewExecutiveReport: 1,
};

class Policy implements StoredEntity {
    static classInternalName = 'policy';

    static fields: EntityFieldCollection = {
        id: idField,
        createdAt: createdAtField,
        entityActions: {
            displayName: 'Entity Actions',
            recordName: 'entity_actions',
            dataType: {
                primitive: 'simple-entity',
                isArray: true,
                extraData: {
                    model: () => PolicyEntityAction,
                },
            },
            supportsQuery: false,
            supportsSort: false,
            needToCreate: true,
            canEdit: true,
            isOptional: false,
            displayOnMain: true,
        },
        permissionActions: {
            displayName: 'Permission Actions',
            recordName: 'permission_actions',
            dataType: {
                primitive: 'enum',
                isArray: true,
                extraData: {
                    [PolicyPermissionAction.viewExecutiveReport]: 'View Executive Report',
                },
            },
            supportsQuery: false,
            supportsSort: false,
            needToCreate: true,
            canEdit: true,
            isOptional: false,
            displayOnMain: true,
        },
    };

    static fileFields: EntityFieldCollection = {};

    static defaultSort: SortParams = getCreatedAtSort('created_at');

    get id() {
        return this.record[Policy.fields.id.recordName];
    }

    get displayName() {
        return this.record[Policy.fields.id.recordName];
    }

    static endpoints: Endpoints = constructEndpoints('policies');

    constructor(record: any) {
        this.record = record;
    }
}

export default Policy;
